module.exports = __webpack_public_path__ + "img/icons8-cloud-user_1.8cdb5bd8.svg";